export default __webpack_public_path__ + "static/media/admin-login-icon.40c08f92.svg";